var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.getImageSource(),"aspect-ratio":_vm.aspectRatio,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth,"position":_vm.position,"contain":_vm.contain}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }